import PropTypes from 'prop-types';
var defaultProps = {
  onSubmitFilter: () => {},
  onClearFilter: () => {},
  onClose: () => {},
  media: {},
  hasFilterChanged: false,
  bedsMax: 5,
  bathsMax: 5,
  parkingMax: 5,
  visibilityPeriod: 'few weeks'
};
export default {
  bedsMax: PropTypes.number,
  bathsMax: PropTypes.number,
  parkingMax: PropTypes.number,
  priceRanges: PropTypes.arrayOf(PropTypes.shape({
    start: PropTypes.number.isRequired,
    end: PropTypes.number.isRequired,
    step: PropTypes.number.isRequired
  })).isRequired,
  onSubmitFilter: PropTypes.func,
  onClearFilter: PropTypes.func,
  onCancel: PropTypes.func,
  media: PropTypes.shape({
    desktop: PropTypes.bool,
    tablet: PropTypes.bool
  }),
  hasFilterChanged: PropTypes.func,
  filters: PropTypes.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  visibilityPeriod: PropTypes.string
};
export { defaultProps };